<script setup lang="ts">
import { SaveOutlined, CloseOutlined } from '@ant-design/icons-vue';
import { notification } from 'ant-design-vue';
import axios from 'axios';
import { reactive, ref } from 'vue';
import { API_URL } from '~/utils';

const emit = defineEmits(['close']);

const formRef = ref<any>(null);
const planilhaRef = ref<any>(null);
const anexosRef = ref<any>(null);
const status = ref<'idle' | 'loading' | 'success' | 'error'>('idle');

const model = reactive<{
  planilha: any;
  anexos: any;
}>({
  planilha: null,
  anexos: null,
});

async function submit() {
  try {
    await formRef.value.validate();

    status.value = 'loading';

    // Upload dos arquivos
    await planilhaRef.value.upload();
    await anexosRef.value.upload();

    // Preparar dados no formato FormValue
    const requestData = {
      planilha: { changed: true, value: model.planilha },
      anexos: { changed: true, value: model.anexos },
    };

    // Enviar para o endpoint
    await axios.post(
      `${API_URL}/importacoes/importar-atualizacoes-gcpj`,
      requestData,
      { getAccessToken: true, timeout: 120000 } as any,
    );

    status.value = 'success';
  }
  catch (error: any) {
    status.value = 'error';

    const errorMessage = error?.response?.data?.errorMessage
      || 'Erro ao processar a importação';

    notification.error({
      message: errorMessage,
      duration: 10,
    });
  }
}
</script>

<template>
  <div>
    <a-form
      v-if="status !== 'success'"
      ref="formRef"
      :model="model"
      layout="vertical"
    >
      <a-form-item
        label="Planilha"
        name="planilha"
        :rules="{
          message: 'Planilha é obrigatória',
          required: true,
          trigger: 'change',
          type: 'object',
        }"
      >
        <UploadFile
          ref="planilhaRef"
          v-model:file="model.planilha"
        />
      </a-form-item>

      <a-form-item
        label="Anexos"
        name="anexos"
        :rules="{
          message: 'Anexos é obrigatório',
          required: true,
          trigger: 'change',
          type: 'object',
        }"
      >
        <UploadFile
          ref="anexosRef"
          v-model:file="model.anexos"
        />
      </a-form-item>

      <a-form-item>
        <a-button
          type="primary"
          size="large"
          :loading="status === 'loading'"
          @click="submit"
        >
          <template #icon>
            <SaveOutlined />
          </template>
          Importar
        </a-button>
        <a-button
          size="large"
          style="margin-left: 8px"
          @click="() => emit('close')"
        >
          <template #icon>
            <CloseOutlined />
          </template>
          Fechar
        </a-button>
      </a-form-item>
    </a-form>

    <a-result
      v-if="status === 'success'"
      status="success"
      title="Importação enviada com sucesso"
      sub-title="O processamento está sendo executado em background. Verifique os logs para detalhes."
    >
      <template #extra>
        <a-button @click="() => emit('close')">
          Fechar
        </a-button>
      </template>
    </a-result>
  </div>
</template>
